module.exports = __webpack_public_path__ + "static/media/challenge.b3cc3fd8.png";